export default class Breakpoints {
  static get() {
    return window
      .getComputedStyle(document.querySelector('body'), '::after')
      .getPropertyValue('content')
      .replace(/"/g, '')
      .split(' ')
  }

  static has(breakpoint) {
    return Breakpoints.get().includes(breakpoint)
  }

  static is() {
    return Breakpoints.get().slice(-1)[0]
  }
}
